import request from "../utils/request";

/**
 * 获取各交易所的专属注册链接。
 * 返回顺序与原 App 一致：OKX、Binance、Gate.io、Bybit。
 */
export const getReferralLink = (hideLoad = true) => request({
    method: 'GET',
    url: '/subSale/getReferralLink',
    params: {hideLoad, requestTimes: 10},
    timeout: 10000
})

/**
 * 获取直推用户列表
 * @param pageNum
 * @returns {AxiosPromise}
 */
export const getRecommendList=(pageNum,pageSize)=>request({
    method:'GET',
    url:'/subSale/getRecommendUserListByPage',
    params:{pageNum,pageSize}
})

/**
 * 邀新购卡返现活动配置（公开接口）。
 */
export const getInviteCashbackConfig=()=>request({
    method:'GET',
    url:'/other/getInviteCashbackConfig',
    skipLocaleQuery:true,
    skipTokenQuery:true,
    params:{requestTimes:10}
})

/**
 * 当前登录用户的邀请统计和分享链接。
 */
export const getInviteCashbackSummary=()=>request({
    method:'GET',
    url:'/other/getInviteCashbackSummary',
    skipLocaleQuery:true,
    skipTokenQuery:true,
    params:{requestTimes:10}
})

/**
 * 当前登录用户的邀请记录。
 */
export const getInviteCashbackRecords=(pageNum=1,pageSize=20,status='all')=>request({
    method:'GET',
    url:'/other/getInviteCashbackRecords',
    skipLocaleQuery:true,
    skipTokenQuery:true,
    params:{pageNum,pageSize,status,requestTimes:10}
})

/**
 * 本月奖励记录
 * @param pageNum
 * @returns {AxiosPromise}
 */
export const getAwardList=(pageNum,pageSize)=>request({
    method:'GET',
    url:'/subSale/getCommissionRecordListByPage',
    params:{pageNum,pageSize}
})

/**
 *  本月资产记录
 * @param pageNum
 * @returns {AxiosPromise}
 */
export const getCapitalList=(pageNum,pageSize)=>request({
    method:'GET',
    url:'/subSale/getDepositRecordListByPage',
    params:{pageNum,pageSize}
})

/**
 * 获取用户信息
 * @returns {AxiosPromise}
 */
export const getUserInfo=()=>request({
        method:'GET',
        url:'/subSale/getUserInfo',
})

/**
 * 推广二维码
 * @returns {AxiosPromise}
 */
export const getQrCode=()=>request({
    method:'GET',
    url:'/subSale/getUserQrCode',
    responseType:'blob',

})
/**
 * 奖励余额转到保证金资产
 */
export const transferProperty=()=>request({
    method:'GET',
    url:'/subSale/operateTransferReward',
})

/**
 * 提现
 */
export const userWithdraw=(address,money,vCode)=>request({
    method:'post',
    url:'/wallet/applyWithdraw',
    params:{address,money,vCode,sendType:1}
})

/**
 * 提现New
 */
export const userWithdrawNew=(address,money,vCode,sendType=1)=>request({
    method:'get',
    url:'/wallet/applyWithdrawNew',
    params:{address,money,vCode,sendType}
})

/**
 * 内部转账
 */
export const internalWithdraw=(address,money,vCode,sendType=1)=>request({
    method:'get',
    url:'/wallet/internalWithdraw',
    params:{address,money,vCode,sendType}
})

/**
 * 設置上級
 */
export const setSuperior=(parentInvitation)=>request({
    method:'get',
    url:'/subSale/modifyParentInvitation',
    params:{parentInvitation}
})

/**
 * 修改备注名
 * @param invitation
 * @param tag
 * @returns {AxiosPromise}
 */
export const setRecommendUserTag = (invitation, tag) =>request({
    method: 'POST',
    url: '/subSale/setRecommendUserTag',
    params:{invitation, tag}
})
